import React, { useState, useEffect } from "react";
import { Table, Icon, Input } from "semantic-ui-react";

export function TableAlumnosR(props) {
  const { grupo, alumnos } = props;
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [realTimeSearch, setRealTimeSearch] = useState("");
  const [alumnoSearch, setAlumnoSearch] = useState("");
  const [rowIndex, setRowIndex] = useState(1);

  useEffect(() => {
    setSearchText(searchText.toLowerCase());
    setAlumnoSearch(alumnoSearch.toLowerCase());
  }, [searchText, alumnoSearch]);

  const handleRealTimeSearchChange = (value) => {
    setRealTimeSearch(value);
    setCurrentPage(1);
  };
  const filteredAlumnos = () => {
    return alumnos.filter(
      (alumno) =>
        alumno.nombre.toLowerCase().includes(realTimeSearch) &&
        alumno.apellido_paterno.toLowerCase().includes(alumnoSearch)
    );
  };

  useEffect(() => {
    const lastPage = Math.ceil(filteredAlumnos().length / itemsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
    // eslint-disable-next-line
  }, [alumnos, currentPage, searchText, alumnoSearch]);

  const paginatedAlumnos = filteredAlumnos().slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div>
      <div className="buscar">
        <Icon name="search" className="bot" />
        <Input
          placeholder="Buscar por nombre"
          value={realTimeSearch}
          onChange={(e) => handleRealTimeSearchChange(e.target.value)}
          className="busper"
        />
      </div>
      <h4>Total de alumnos: {grupo.alumnos.length}</h4>
      <Table className="table-users-admin">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>NUM. DE LISTA</Table.HeaderCell>
            <Table.HeaderCell>CURP</Table.HeaderCell>
            <Table.HeaderCell>MATRICULA</Table.HeaderCell>
            <Table.HeaderCell>APELLIDO PATERNO</Table.HeaderCell>
            <Table.HeaderCell>APELLIDO MATERNO</Table.HeaderCell>
            <Table.HeaderCell>NOMBRE</Table.HeaderCell>
            <Table.HeaderCell>SEMESTRE</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {paginatedAlumnos
            .sort((a, b) =>
              a.apellido_paterno.localeCompare(b.apellido_paterno)
            )
            .map((alumnoo, index) => (
              <Table.Row key={index}>
                <Table.Cell>{rowIndex + index}</Table.Cell>
                <Table.Cell>{alumnoo.curp}</Table.Cell>
                <Table.Cell>{alumnoo.matricula}</Table.Cell>
                <Table.Cell>{alumnoo.apellido_paterno}</Table.Cell>
                <Table.Cell>{alumnoo.apellido_materno}</Table.Cell>
                <Table.Cell>{alumnoo.nombre}</Table.Cell>
                <Table.Cell>{alumnoo.semestre}</Table.Cell>
                {/*<Actions
                  alumno={alumnoo}
                  reinscribirAlumno={reinscribirAlumno}
                  bajaTemporalAlmuno={bajaTemporalAlmuno}
            />*/}
              </Table.Row>
            ))}
        </Table.Body>
      </Table>
      <div style={{ textAlign: "center", marginTop: "10px" }}></div>
    </div>
  );
}

/*
function Actions(props) {
  const { alumno, reinscribirAlumno, bajaTemporalAlmuno } = props;
  return (
    <Table.Cell textAlign="center">
      <div className="action-buttons">
        <Button
          className="green"
          icon
          onClick={() => {
            reinscribirAlumno(alumno);
          }}
        >
          <Icon name="sync" style={{ color: "white" }}></Icon>
        </Button>
        <Button
          icon
          className="yellow"
          onClick={() => {
            bajaTemporalAlmuno(alumno);
          }}
        >
          <Icon name="minus circle" style={{ color: "white" }}></Icon>
        </Button>
      </div>
    </Table.Cell>
  );
}*/
